<template>
  <div class="Index">
    <bannerSection></bannerSection>
    <!-- ================================================正式内容===================================================== -->
    <header-section></header-section>
    <project />
    <floating-banner></floating-banner>
  </div>
</template>

<script>
import bannerSection from '../index/bannerSection'
import headerSection from './headerSection'
import project from './project'
import floatingBanner from '../index/floatingBanner'
export default {
  name: 'StartYourProject',
  components: {
    bannerSection,
    headerSection,
    project,
    floatingBanner
  },
  data() {
    return {}
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/startYourProject/Index.vue